// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {SpinnerEl} from 'common/components/spinner/panel';
import {ToggleEl} from 'common/components/toggle/panel';
import {ToggleSize} from 'common/components/toggle/types';
import {BrowserContextRootEl} from 'common/widgets/browser-context-root';

import type {CPRAPreferences} from './index';

export function template(this: CPRAPreferences) {
  return (
    <BrowserContextRootEl>
      <div sel='.cookie-center'>
        <div sel='.header'> Your Privacy Rights </div>
        <div sel='.description'>
          California residents can request to opt-out of the sharing of their personal information for cross-contextual
          behavioral advertising purposes and/or from the sale of their personal information for monetary or other
          valuable consideration.
        </div>
        <div sel='.description'>
          If you are a California resident and you would like to exercise your right to opt-out of the sharing of your
          personal information, you may do so by clicking on the “opt-out” button below. Please note that we do not sell
          personal information as defined by the CCPA. For a description of the information we collect, the technologies
          we use and the third parties with who we may share information, please refer to our{` `}
          <a attrs={{href: `/legal/privacy-policy/`}}>Privacy Statement.</a>
        </div>
        <div sel='.toggle-header'>
          <div sel='.toggle-section'>
            {this.state.optStatus === null ? (
              <SpinnerEl />
            ) : (
              <ToggleEl
                size={ToggleSize.Large}
                selected={this.state.optStatus}
                options={[
                  {label: `Opt In`, value: `in`, icon: `checkmark`},
                  {label: `Opt Out`, value: `out`, icon: `x`},
                ]}
                onSelect={this.helpers.handleSwitchChange}
              />
            )}
          </div>
        </div>
      </div>
    </BrowserContextRootEl>
  );
}
